package fr.manyverse.app.presentation.components.welcome

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.WorkspacePremium
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.lerp
import androidx.compose.ui.unit.dp
import fr.manyverse.app.domain.model.GameTable
import fr.manyverse.app.domain.model.MemberRole
import fr.manyverse.app.presentation.theme.rememberUniverseColorScheme
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.event_author_game_master
import org.jetbrains.compose.resources.stringResource
import androidx.compose.foundation.isSystemInDarkTheme

@Composable
fun ActiveTableCard(
    table: GameTable,
    role: MemberRole,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val universeName = table.universeConfig.displayName.takeIf { it.isNotBlank() }
        ?: table.universeId

    val universeScheme = rememberUniverseColorScheme(table.resolvedConfig, isSystemInDarkTheme())
    // Couleur vive de l'univers utilisée comme accent (barre gauche + nom d'univers)
    val accentColor = universeScheme.primary
    // Fond très légèrement teinté de l'accent, sur la base neutre du surface de l'app
    val cardBackground = lerp(MaterialTheme.colorScheme.surface, accentColor, 0.10f)
    val borderColor = accentColor.copy(alpha = 0.45f)

    Card(
        modifier = modifier
            .fillMaxWidth()
            .clickable(onClick = onClick),
        colors = CardDefaults.cardColors(containerColor = cardBackground),
        border = BorderStroke(1.dp, borderColor),
        elevation = CardDefaults.cardElevation(defaultElevation = 0.dp)
    ) {
        Row(modifier = Modifier.height(IntrinsicSize.Min)) {
            // Barre d'accent verticale à gauche
            Box(
                modifier = Modifier
                    .width(4.dp)
                    .fillMaxHeight()
                    .background(accentColor)
            )

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(16.dp),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(
                    modifier = Modifier.weight(1f),
                    verticalArrangement = Arrangement.spacedBy(2.dp)
                ) {
                    Text(
                        text = table.name,
                        style = MaterialTheme.typography.titleMedium,
                        color = MaterialTheme.colorScheme.onSurface
                    )
                    Text(
                        text = universeName,
                        style = MaterialTheme.typography.labelSmall,
                        color = accentColor
                    )
                }

                // Role indicator (only shown for Game Master) — neutre, pas d'accent
                if (role == MemberRole.GAME_MASTER) {
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(4.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Icon(
                            imageVector = Icons.Default.WorkspacePremium,
                            contentDescription = null,
                            tint = MaterialTheme.colorScheme.onSurfaceVariant,
                            modifier = Modifier.size(20.dp)
                        )
                        Text(
                            text = stringResource(Res.string.event_author_game_master),
                            style = MaterialTheme.typography.labelMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                    }
                }
            }
        }
    }
}
